<template>
  <v-card flat
          tile
          style="max-width: 220px;">
    <v-card-title class="px-0 pb-2 d-flex justify-space-between">
      <div class="d-inline-block text-truncate text-subtitle-1"
           style="max-width: 190px;"
           :title="result.display_name">
        {{ result.display_name }}
      </div>
      <v-btn v-if="1===2"
             icon
             x-small
             @click.prevent="reprocessScreenshot">
        <v-icon>
          fal fa-sync
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-card-subtitle class="px-0 pb-1">
      {{ result.os }}
    </v-card-subtitle>
    <div>
      <a v-if="isComplete"
         @click.prevent="showResult"
         :href="fullThumbnail"
         target="_blank">
        <v-img :src="fullThumbnail"
               position="top center"
               style="border: 1px solid rgba(0, 0, 0, 0.15)"
               max-width="220"
               max-height="476"
               class="grey lighten-2">
        </v-img>
      </a>
      <v-img v-else
             :src="placeholder"
             style="border: 1px solid rgba(0, 0, 0, 0.15)"
             max-width="220"
             max-height="476"
             class="grey lighten-2">
      </v-img>
    </div>
  </v-card>
</template>
<script>
import {isObject} from 'lodash';
import emailPreviewService from '../../../services/emailPreviewService';
import {mapGetters} from 'vuex';

export default {
  props: {
    result: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('emailPreviews', [
      'preview',
    ]),
    isComplete() {
      return this.result.status === 'Complete';
    },
    screenshots() {
      return this.result.screenshots;
    },
    hasDefaultThumbnail() {
      if (isObject(this.screenshots)) {
        return !!this.screenshots.default;
      }
      return false;
    },
    defaultThumbnail() {
      if (this.hasDefaultThumbnail) {
        return this.screenshots.default;
      }
      return null;
    },
    hasHorizontalThumbnail() {
      if (isObject(this.screenshots)) {
        return !!this.screenshots.horizontal;
      }
      return false;
    },
    horizontalThumbnail() {
      if (this.hasHorizontalThumbnail) {
        return this.screenshots.horizontal;
      }
      return null;
    },
    hasFullThumbnail() {
      if (isObject(this.result)) {
        return !!this.result.full_thumbnail;
      }
      return false;
    },
    fullThumbnail() {
      if (this.hasFullThumbnail) {
        return this.result.full_thumbnail;
      }
      return null;
    },
    placeholder() {
      return 'https://placehold.co/340x190?text=Loading';
    },
  },
  methods: {
    reprocessScreenshot() {
      emailPreviewService.reprocessScreenshot(this.preview.id, this.result.id)
        .then(() => {
          this.$emit('updated');
        })
    },
    async showResult() {
      await this.$store.dispatch('emailPreviews/setResult', this.result);
      await this.$store.dispatch('emailPreviews/setShowingResultDialog', true);
    },
  }
}
</script>
